import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Projects from "./Pages/Projects";
import Technologies from "./Pages/Technologies";
import ProjectDetailsPage from "./Components/ProjectDetailsPage";
function App() {
  return (
    <div className="container mx-auto  ">
    <Router >
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/technologies" element={<Technologies />} />
        <Route path="/project/:id" element={<ProjectDetailsPage />} />

      </Routes>
      <Footer />
    </Router>
    </div>
  );
}
export default App;
